import { render } from "./InputFile.vue?vue&type=template&id=5485882f"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__